module.exports = __webpack_public_path__ + "img/landing_page_background@2x.b8f2c5b.jpg";